<template>
  <el-dialog
    center
    width="600px"
    :title="dialogTitle"
    :visible.sync="dialogFormVisible"
    @close="resetFrom('editForm')"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item
        label="所属楼盘"
        :label-width="formLabelWidth"
        prop="houseId"
      >
        <el-select
          v-model="editForm.houseId"
          filterable
          placeholder="请选择楼盘"
        >
          <el-option
            v-for="item in houseData"
            :key="item.houseId"
            :label="item.houseName"
            :value="item.houseId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="动态标题" :label-width="formLabelWidth" prop="title">
        <el-input v-model="editForm.title" auto-complete="off"></el-input>
      </el-form-item>

      <el-form-item label="动态图片" :label-width="formLabelWidth" prop="pic">
        <el-upload
          class="avatar-uploader"
          :action="actionUrl"
          :http-request="httpRequest"
          :before-upload="beforeAvatarUpload"
          :on-remove="handleRemove"
        >
          <img v-if="editForm.pic" :src="editForm.pic" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item
        label="正文内容"
        :label-width="formLabelWidth"
        prop="content"
      >
        <el-input
          v-model="editForm.content"
          type="textarea"
          :rows="4"
          auto-complete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="动态排序" :label-width="formLabelWidth" prop="sort">
        <el-input
          type="number"
          v-model="editForm.sort"
          auto-complete="off"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button
        @click="
          resetFrom('editForm');
          dialogFormVisible = false;
        "
        >取 消</el-button
      >
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { formData, formRules } from '../form.js';
import { getHouseNewsList } from '@/api/areaApi.js';
//import { houseList } from '@/api/houseApi.js';
import {
  houseNewsUpload,
  editHouseNewsApi,
  addHouseNewsApi,
} from '@/api/areaApi.js';
export default {
  data() {
    return {
      houseNewsId: '',
      houseId: '',
      dialogTitle: '',
      dialogFormVisible: false,
      isSortRepeat: false,
      actionUrl: '',
      editForm: { ...formData },
      editRules: formRules,
      formLabelWidth: '120px',
      houseData: [],
      newsDate: [],
    };
  },
  inject: ['reload'],

  methods: {
    async getList(id, sort, newsId) {
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      await getHouseNewsList({
        houseId: id,
        areaId,
        // pageIndex: 1,
        // pageSize:1000
      }).then((res) => {
        this.newsDate = res.data.dataList;
        let s = parseInt(sort);
        let i = newsId;
        let data = this.newsDate.filter((item) => {
          return item.sort === s && item.newsId != i;
        });
        if (data != '') this.isSortRepeat = true;
      });
    },
    resetFrom() {
      this.editForm = {};
    },

    handleRemove() {
      this.editForm.pic = '';
    },
    // 上传图片前验证规则
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      //const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
      }
      /*  if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M; */
      return isJPG;
    },
    httpRequest(options) {
      let file = options.file;
      let reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file);
      }
      reader.onload = () => {
        let base64Str = reader.result;
        this.dealImg(options, base64Str, file);
      };
    },
    dealImg(options, base64Str, file) {
      let _this = this;
      var image = new Image();
      image.src = base64Str;
      image.setAttribute('crossOrigin', 'Anonymous');

      image.onload = function () {
        // 缩放图片需要的canvas（也可以在DOM中直接定义canvas标签，这样就能把压缩完的图片不转base64也能直接显示出来）
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');

        // 图片原始尺寸
        var originWidth = this.width;
        var originHeight = this.height;

        // 最大尺寸限制，可通过设置宽高来实现图片压缩程度
        var maxWidth = 4200,
          maxHeight = 4200;
        // 目标尺寸
        var targetWidth = originWidth,
          targetHeight = originHeight;
        // 图片尺寸超过300x300的限制
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > maxWidth / maxHeight) {
            // 更宽，按照宽度限定尺寸
            targetWidth = maxWidth;
            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
          } else {
            targetHeight = maxHeight;
            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
          }
        }

        canvas.width = targetWidth;
        canvas.height = targetHeight;

        context.clearRect(0, 0, targetWidth, targetHeight);

        context.drawImage(image, 0, 0, targetWidth, targetHeight);

        var base64 = canvas.toDataURL('image/jpeg', 0.92); //base64 格式
        const areaId = localStorage.getItem('areaId')
          ? JSON.parse(localStorage.getItem('areaId')).areaId
          : '';
        houseNewsUpload({
          base64String: base64,
          fileName: file.name,
          areaId,
        })
          .then((res) => {
            _this.$set(_this.editForm, 'pic', res.data.absoluteFileUrl);
          })
          .catch((err) => {
            window.console.log(err);
          });
      };
    },

    async submitEdit() {
      try {
        this.$refs.editForm.validate(async (valid) => {
          if (!valid) return this.$message.error('格式不对哦，检查一下呗!');
          await this.getList(
            this.editForm.houseId,
            this.editForm.sort,
            this.editForm.newsId
          );

          if (this.houseNewsId != '') {
            const areaId = localStorage.getItem('areaId')
              ? JSON.parse(localStorage.getItem('areaId')).areaId
              : '';
            await editHouseNewsApi(this.houseNewsId, {
              ...this.editForm,
              areaId,
            }).then((res) => {
              if (res.code === 200) {
                this.$message.success('编辑成功!');

                if (this.isSortRepeat) {
                  this.$message({
                    message: '动态排序有冲突，请注意修改!',
                    type: 'warning',
                    offset: 60,
                  });
                }
              } else {
                this.$message.success('编辑失败!');
                return;
              }
            });
          } else {
            const areaId = localStorage.getItem('areaId')
              ? JSON.parse(localStorage.getItem('areaId')).areaId
              : '';
            await addHouseNewsApi({ ...this.editForm, areaId }).then((res) => {
              if (res.code === 200) {
                this.$message.success('添加成功!');

                if (this.isSortRepeat) {
                  this.$message({
                    message: '动态排序有冲突，请注意修改!',
                    type: 'warning',
                    offset: 60,
                  });
                }
              } else {
                this.$message.success('添加失败!');
                return;
              }
            });
          }
          this.dialogFormVisible = false;
          this.editForm = {};
          this.isSortRepeat = false;
          this.reload();
        });
      } catch (e) {
        window.console.log(e);
      }
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}
.avatar {
  width: 100px;
  display: block;
}
</style>
